export default {
  data() {
    return {
      confirmationDialogShow: false,

      confirmationDialogTitle: '',
      confirmationDialogMessage: '',

      confirmationDialogSubmitButtonText: '',
      confirmationDialogSubmitButtonIcon: '',
      confirmationDialogSubmitButtonColor: '',
      confirmationDialogSubmitCb: null,

      confirmationDialogCancelButtonText: '',
      confirmationDialogCancelCb: null,

      confirmationDialogShowCancelButton: true,
    }
  },
  computed: {},
  methods: {
    showConfirmationDialog({
      title,
      message,
      submitButtonText,
      submitButtonIcon,
      submitButtonColor,
      submitCb,
      showCancelButton,
      cancelButtonText,
      cancelCb,
    } = {}) {
      this.confirmationDialogTitle = title
      this.confirmationDialogMessage = message

      this.confirmationDialogSubmitButtonText = submitButtonText
      this.confirmationDialogSubmitButtonIcon = submitButtonIcon
      this.confirmationDialogSubmitButtonColor = submitButtonColor || 'primary'
      this.confirmationDialogSubmitCb = submitCb

      this.confirmationDialogCancelButtonText = cancelButtonText
      this.confirmationDialogCancelCb = cancelCb

      this.confirmationDialogShowCancelButton = showCancelButton === false ? false : true
      if (this.confirmationDialogShow === true) {
        this.confirmationDialogShow = false
      }
      this.$nextTick(() => {
        this.confirmationDialogShow = true
      })
    },
    onConfirmationDialogSubmitClicked() {
      try {
        if (this.confirmationDialogSubmitCb) {
          this.confirmationDialogSubmitCb()
        }
      } finally {
        this.resetConfirmationDialog()
      }
    },
    onConfirmationDialogCancelClicked() {
      try {
        if (this.confirmationDialogCancelCb) {
          this.confirmationDialogCancelCb()
        }
      } finally {
        this.resetConfirmationDialog()
      }
    },
    resetConfirmationDialog() {
      this.confirmationDialogShow = false

      this.confirmationDialogTitle = ''
      this.confirmationDialogMessage = ''

      this.confirmationDialogSubmitButtonText = ''
      this.confirmationDialogSubmitButtonIcon = ''
      this.confirmationDialogSubmitButtonColor = ''
      this.confirmationDialogSubmitCb = null

      this.confirmationDialogCancelButtonText = ''
      this.confirmationDialogCancelCb = null

      this.confirmationDialogShowCancelButton = true
    },
  },
}